import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { DurationService } from 'src/app/services/duration.service';
import { Licence, Profile } from 'src/app/services/jsonrpc/user-server.service';

@Component({
  selector: 'app-vrspeech-trainer-modal',
  templateUrl: './vrspeech-trainer-modal.component.html',
  styleUrls: ['./vrspeech-trainer-modal.component.scss']
})
export class VRSpeechTrainerModalComponent implements OnInit {
  public update: boolean;
  public licence: Licence;

  @Input() public profile: Profile = null;
  @Input() public profiles: Profile[] = [];
  @Input() public licences: Licence[] = [];

  @Output() public onSubmit = new EventEmitter<{ profile: Profile; licence: Licence }>();

  public get title(): string {
    return this.update ? 'Add Licence' : 'Create Trainer Account';
  }

  constructor(public duration: DurationService, public modal: NgbActiveModal) {}

  ngOnInit(): void {
    this.update = this.profile != null;
    this.profiles = this.profiles.sort((a, b) => this.compareString(a.username, b.username));
    this.licences = this.licences.sort((a, b) => this.compareString(a.key, b.key));
  }

  public submit() {
    this.onSubmit.emit({ profile: this.profile, licence: this.licence });
    this.modal.close();
  }

  private compareString(a: string, b: string): number {
    if (a === b) return 0;
    else if (!a) return -1;
    else if (!b) return 1;
    else return a.toUpperCase() > b.toUpperCase() ? 1 : -1;
  }

  public dbg() {
    console.log('Licence: ', this.licence);
  }
}
